
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#3a3a3a"}}),_c('path',{staticClass:"b",attrs:{"d":"M16.903 6.933a4.584 4.584 0 012.85 2.144 4.042 4.042 0 11-4.847-1.91c.2-.068.39-.156.58-.234zM16.197 25.064c-1.676 0-3.352.01-5.023 0a1.93 1.93 0 01-2.1-2.3 7.126 7.126 0 0113.68-2.392 9.092 9.092 0 01.56 2.606 1.834 1.834 0 01-1.954 2.085c-1.718.013-3.443.001-5.163.001z"}})])
          )
        }
      }
    